import React, { Component } from 'react'

class NoContentBox extends Component {
  render () {
    return (
      <div className={!this.props.hidden ? 'no-content-box-wrapper' : 'no-content-box-wrapper-hidden'}>
        <div className='no-content-box-text-wrapper'>
          <i className={'fa fa-' + this.props.icon} />
          <h3 className='text-center no-data-text'>{this.props.text}</h3>
        </div>
      </div>
    )
  }
}
export default NoContentBox



// WEBPACK FOOTER //
// ./src/components/basic/displays/NoContentBox.js